module.exports = {
	"data": {
		"allMarkdown": {
			"edges": [
				{
					"node": {
						"fields": {
							"slug": "/lesson-eight"
						},
						"excerpt": "Operating model: Approvals meetings To ensure DMGT meets your business critical deadlines, we have in place a weekly Approvals Meeting to...",
						"timeToRead": 2,
						"frontmatter": {
							"title": "Lesson Eight ",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-eleven"
						},
						"excerpt": "Page 16  Strategy (cont.) New capital expenditure approvals table US Dollar equivalent at £1:$1.5",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Lesson Eleven",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-nine"
						},
						"excerpt": "2. Operating Procedures LINKS TO THE LESSIONS IN THIS SECTION",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Lesson Nine",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-ten"
						},
						"excerpt": "Page 15 Strategy The Strategy and Performance Management team is tasked with setting overall Group strategy, including the allocation of...",
						"timeToRead": 3,
						"frontmatter": {
							"title": "Lesson Ten ",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-twelve"
						},
						"excerpt": "Page 18  Mergers, acquisitions and investments Early communication of all merger, acquisition, investment and disposal activities is...",
						"timeToRead": 3,
						"frontmatter": {
							"title": "Lesson Twelve",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-five"
						},
						"excerpt": "Operating model: governance calendar As a public company DMGT is required to have a formal Board and governance procedures in place to...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Lesson Five",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-four"
						},
						"excerpt": "DMGT encourages employees to report behaviour they see that is in breach of the Green Book, the Code of Conduct, or any other illegal or...",
						"timeToRead": 2,
						"frontmatter": {
							"title": "Lesson Four",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/1-dmgt-at-a-glance"
						},
						"excerpt": "DMGT manages a balanced multinational portfolio of entrepreneurial companies,with total revenues of around £1.5 billion, that provide a...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "1. DMGT at a glance ",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-six"
						},
						"excerpt": "Operating model: operating rhythm To ensure interactions with DMGT are productive and predictable, an operating rhythm of informal catch ups...",
						"timeToRead": 2,
						"frontmatter": {
							"title": "Lesson Six",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-three-code-of-conduct"
						},
						"excerpt": "The Green Book should be read together with the Code of Conduct as they form part of a suite of communications covering governance. The Code...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Lesson Three - Code of Conduct",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-two-scope-and-responsibilities"
						},
						"excerpt": "Scope and responsibilities The Green Book is a guide which sets out key processes, controls and information for DMGT Operating Companies...",
						"timeToRead": 8,
						"frontmatter": {
							"title": "Lesson Two - Scope and responsibilities",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/one-to-delete"
						},
						"excerpt": "To see if deletions work ok?  J ",
						"timeToRead": 1,
						"frontmatter": {
							"title": "One to delete",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/lesson-seven"
						},
						"excerpt": "Operating model: operating rhythm (cont.) Approvals meetings DMGT CEO and CFO Meets weekly (prior to the Executive Committee) Pre-vet items...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Lesson Seven ",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/that-markdown-cheat"
						},
						"excerpt": "NOTE: This \"post\" is based on  Markdown Cheatsheet  and is meant to test styling of Markdown generated documents. This is intended as a...",
						"timeToRead": 8,
						"frontmatter": {
							"title": "That markdown cheat ",
							"tags": null,
							"date": null
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/newest-post"
						},
						"excerpt": "This a brand new post",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Newest post",
							"tags": [
								"foo"
							],
							"date": "2018-07-23T12:01:36-04:00"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/new-post"
						},
						"excerpt": "foo bar is here",
						"timeToRead": 1,
						"frontmatter": {
							"title": "New post",
							"tags": [
								"posts"
							],
							"date": "2018-07-23T11:55:10-04:00"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/post-one"
						},
						"excerpt": "Spicy jalapeno cupidatat foo chicken ut filet mignon sausage ut boudin nulla reprehenderit strip steak proident cillum incididunt short loin...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Post One",
							"tags": [
								"programming",
								"stuff",
								"other"
							],
							"date": "01/01/2017"
						}
					}
				}
			]
		},
		"posts": {
			"edges": [
				{
					"node": {
						"fields": {
							"slug": "/newest-post"
						},
						"excerpt": "This a brand new post",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Newest post",
							"tags": [
								"foo"
							],
							"date": "2018-07-23T12:01:36-04:00"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/new-post"
						},
						"excerpt": "foo bar is here",
						"timeToRead": 1,
						"frontmatter": {
							"title": "New post",
							"tags": [
								"posts"
							],
							"date": "2018-07-23T11:55:10-04:00"
						}
					}
				},
				{
					"node": {
						"fields": {
							"slug": "/post-one"
						},
						"excerpt": "Spicy jalapeno cupidatat foo chicken ut filet mignon sausage ut boudin nulla reprehenderit strip steak proident cillum incididunt short loin...",
						"timeToRead": 1,
						"frontmatter": {
							"title": "Post One",
							"tags": [
								"programming",
								"stuff",
								"other"
							],
							"date": "01/01/2017"
						}
					}
				}
			]
		}
	},
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 402
// module chunks = 142629428675168